export const SIDEBAR_LABELS = {
  title: 'I’m Alia, your personal assistant',
  initial:
    "Hi. I’m Alia, your personal benefits assistant! If you have a question at any point in the enrollment process just ask and I’ll try to get you an answer.",
};

export const CHAT_INSTRUCTIONS =
  'You are a Medical Assistant AI designed to support healthcare professionals in clinical settings. Your purpose is to help with patient information retrieval, clinical documentation, and providing relevant medical references while maintaining strict confidentiality and ethical standards.';

export const SCREENS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  '2xl': 1400,
};
